/* eslint-disable import/prefer-default-export */
export const PASSWORD_MIN_LENGTH = 8;
